















import Vue, { PropType } from 'vue'
import { HorizontalListItem } from '@/model/HorizontalListItem'
import VueHorizontalList from 'vue-horizontal-list'
import ItemCard from '@/components/project/ItemCard.vue'

export default Vue.extend({
  name: 'ItemsHorizontalList',
  props: {
    items: {
      type: Array as PropType<HorizontalListItem[]>,
    },
    nameFormat: {
      type: String,
      default: 'full',
    },
  },
  components: {
    VueHorizontalList,
    ItemCard,
  },
  data: () => ({
    vhlOptions: {
      item: {
        padding: 5,
      },
      list: {
        windowed: 960,
        padding: 24,
      },
      responsive: [
        { end: 600, size: 1 },
        { start: 600, end: 960, size: 2 },
        { start: 960, end: 1264, size: 4 },
        { start: 1264, end: 1904, size: 5 },
        { start: 1904, size: 8 },
      ],
      navigation: {
        start: 960,
      },
    },
  }),
})
